import {combineLatest, Subscription} from 'rxjs';
import {filter, map} from 'rxjs/operators';
import {ChangeDetectionStrategy, Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Store} from '@ngxs/store';
import {DashboardState} from '../../../dashboard-new/states/dashboard/dashboard.state';
import {PROGRESS_STATUSES} from '../../../shared/symbols';

@Component({
  selector: 'app-dashboard-study-redirect',
  templateUrl: './dashboard-study-redirect.component.html',
  styleUrls: ['./dashboard-study-redirect.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardStudyRedirectComponent implements OnInit, OnDestroy {
  // Todo: add loaders and error handlers.
  public readonly loadDashboardUserProgress$ = this.store.select(DashboardState.loadDashboardUserProgress);
  public readonly dashboardUser$ = this.store.select(DashboardState.dashboardUser);
  public readonly lastLoadDashboardUserError$ = this.store.select(DashboardState.lastLoadDashboardUserError);

  /** Contain component subscriptions. Will be unsubscribed on destroy. */
  private readonly subscription = new Subscription();

  constructor(private store: Store, private router: Router, private route: ActivatedRoute) {}

  ngOnInit(): void {
    // Select the first available study.
    // Every user has at least one available study.
    // For private users, if no study were uploaded, the backend will provide public studies.
    // For clinic patients, they won't be presented in the list (and cannot be selected) if no studies were uploaded.
    this.subscription.add(
      combineLatest([this.dashboardUser$, this.loadDashboardUserProgress$])
        .pipe(
          filter(([userData, loadUserDataProgress]) => loadUserDataProgress === PROGRESS_STATUSES.SUCCEED && !!userData),
          map(([userData]) => userData)
        )
        .subscribe(userData => {
          this.router.navigate([userData.related_studies[0].id], {relativeTo: this.route})
        })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
